import React from 'react';
import classnames from 'classnames';
import {Trans} from 'react-i18next';
import {skinTypeHdMap} from '../../../setting';
import SkinTypeItem from './SkinTypeItem';

export default function SkinTypes({
  isLandscape,
  detectionMapping,
  activeDetection,
  setActiveDetection,
  activeLang,
  showSkinTypeItems,
  handleShowSkinTypeItemsClick,
}) {
  return (
    <div
      className={classnames({
        'skincaredetectionpreview-detections__skintype': true,
        'skincaredetectionpreview-detections__skintype--landscape': isLandscape,
      })}
    >
      <div
        className={classnames({
          'skincaredetectionpreview-detections__skintype-background': true,
          'skincaredetectionpreview-detections__skintype-background--not-show-item': !showSkinTypeItems,
          'skincaredetectionpreview-detections__skintype-background--landscape': isLandscape,
        })}
        onClick={handleShowSkinTypeItemsClick}
      />
      <div
        className={classnames({
          'skincaredetectionpreview-detections__detection': true,
          'skincaredetectionpreview-detections__detection--landscape': isLandscape,
        })}
      >
        <img
          src={require('../../../../../../../../assets/images/skincare/hddetectionicon/non_sensitive.png')}
          alt="non_sensitive"
          className={classnames({
            'cursor-pointer': true,
            'skincaredetectionpreview-detections__detection-icon': true,
          })}
          onClick={() => {
            if (!showSkinTypeItems) {
              handleShowSkinTypeItemsClick();
            }
            setActiveDetection('combination_non_sensitive');
          }}
        />
        <div
          className={classnames({
            'skincaredetectionpreview-detections__detection-name': true,
            'skincaredetectionpreview-detections__detection-name--landscape': isLandscape,
          })}
        >
          <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.skintype">
            Skin Type
          </Trans>
        </div>
      </div>
      {showSkinTypeItems &&
        Object.keys(skinTypeHdMap).map(key => (
          <SkinTypeItem
            categoryKey={key}
            detectionMapping={detectionMapping}
            activeDetection={activeDetection}
            setActiveDetection={setActiveDetection}
            isLandscape={isLandscape}
            activeLang={activeLang}
          />
        ))}
      {showSkinTypeItems && (
        <div
          className={classnames({
            'skincaredetectionpreview-detections__skintype-line': true,
            'skincaredetectionpreview-detections__skintype-line--landscape': isLandscape,
          })}
        />
      )}
    </div>
  );
}
